// @flow

import React from 'react'
import { connect } from 'react-redux'
// $FlowFixMe
import { reduxForm, Field } from 'redux-form'
// $FlowFixMe
import { push } from 'connected-react-router'
import styled from 'styled-components'
import { Button, Divider, Title } from 'src/theme/globalStyle'
import { media } from 'src/theme/style-utils'
import { updateBooking } from 'src/ducks/booking'
import { StyledForm } from 'src/components/Form'
import { renderSelect, renderNativeSelect } from 'src/helpers/fieldRenderers'
import { required } from 'src/helpers/validation'
import type { Theme as ThemeType, Room as RoomType, MoveIn as MoveInType } from 'src/types'
import type { State } from 'src/types/redux'
import Option from './CustomOption'

type Props = {
  handleSubmit?: any,
  floorPreference?: any,
  hasRestrictedDuration?: any,
  hasKitchen?: any,
  room?: RoomType,
  roomPrice?: number,
  occupancyType?: string,
  moveIn?: MoveInType,
  pathname?: string,
  roomPriceEdited?: any,
  bookingDepositEdited?: any,
  location?: any,
  yourName?: any,
  bookingDeposit?: any,
  adminFee?: any,
  dispatch?: any,
  allow_cash?: any,
  digitalVerification?: any,
  isAlignedAtStart?: boolean,
  restrictedDuration?: MoveInType
}

const RoomSticky = styled.div`
  box-sizing: border-box;
  background-color: #fff;
  height: 310px;

  ${media.tabletLarge`
    position: sticky;
    top: 60px;
    right: 80px;
    height: auto;
    width: 300px;
    padding: 15px 20px;
    margin-top: -100px;
    margin-left: auto;
    border: 1px solid ${(props: { theme: ThemeType }) => props.theme.secondary}
    border-radius: ${(props: { theme: ThemeType }) => props.theme.borderRadius};
    align-self:${props => (!!props.isAlignedAtStart ? 'flex-start' : 'baseline')} ;
    
  `};

  ${media.desktop`
    width: 400px;
    padding: 20px 30px;
  `};

  ${media.giant`
      width: 450px;
      padding: 20px 40px;
    `};
`

let DetailForm = ({
  handleSubmit,
  floorPreference,
  hasRestrictedDuration,
  hasKitchen,
  room,
  yourName,
  bookingDeposit,
  adminFee,
  roomPrice,
  moveIn,
  restrictedDuration,
  allow_cash,
  digitalVerification,
  occupancyType,
  roomPriceEdited,
  bookingDepositEdited,
  dispatch,
  location,
  isAlignedAtStart
}: Props) => {
  const basePrice = room ? room.basePrice : 0
  const kitchenPremium = hasKitchen ? 10 : 0
  const mq = window.matchMedia('(min-width: 480px)')
  const price = roomPrice
    ? parseInt(roomPrice, 10) +
      parseInt(floorPreference && floorPreference.premium ? floorPreference.premium : 0, 10)
    : parseInt(basePrice, 10) +
      parseInt(floorPreference && floorPreference.premium ? floorPreference.premium : 0, 10) +
      parseInt(kitchenPremium, 10)
  const getDuration = () => {
    let result = []
    if (hasRestrictedDuration === 'restricted') {
      result = [
        {
          label: '12 months',
          value: 12,
          weeklyPrice: price
        },
        {
          label: '9 months',
          value: 9,
          weeklyPrice: price !== 0 ? price + 15 : 0
        }
      ]
    } else if (hasRestrictedDuration === 'semi') {
      result = [
        {
          label: '12 months',
          value: 12,
          weeklyPrice: price
        },
        {
          label: '9 months',
          value: 9,
          weeklyPrice: price !== 0 ? price + 15 : 0
        },
        {
          label: '6 months',
          value: 6,
          weeklyPrice: price !== 0 ? price + 30 : 0
        }
      ]
    } else if (location && location.ref === 'tccw') {
      result = [
        {
          label: '12 months',
          value: 12,
          weeklyPrice: price
        },
        {
          label: '11 months',
          value: 11,
          weeklyPrice: price !== 0 ? price + 5 : 0
        },
        {
          label: '10 months',
          value: 10,
          weeklyPrice: price !== 0 ? price + 10 : 0
        },
        {
          label: '9 months',
          value: 9,
          weeklyPrice: price !== 0 ? price + 20 : 0
        },
        {
          label: '8 months',
          value: 8,
          weeklyPrice: price !== 0 ? price + 25 : 0
        },
        {
          label: '7 months',
          value: 7,
          weeklyPrice: price !== 0 ? price + 30 : 0
        },
        {
          label: '6 months',
          value: 6,
          weeklyPrice: price !== 0 ? price + 50 : 0
        },
        {
          label: '5 months',
          value: 5,
          weeklyPrice: price !== 0 ? price + 60 : 0
        },
        {
          label: '4 months',
          value: 4,
          weeklyPrice: price !== 0 ? price + 80 : 0
        },
        {
          label: '3 months',
          value: 3,
          weeklyPrice: price !== 0 ? price + 100 : 0
        }
      ]
    } else {
      result = [
        {
          label: '12 months',
          value: 12,
          weeklyPrice: price
        },
        {
          label: '9 months',
          value: 9,
          weeklyPrice: price !== 0 ? price + 15 : 0
        },
        {
          label: '6 months',
          value: 6,
          weeklyPrice: price !== 0 ? price + 30 : 0
        },
        {
          label: '4 months',
          value: 4,
          weeklyPrice: price !== 0 ? price + 40 : 0
        }
      ]
      if (room && (room.ref === 'studio' || room.ref === 'ensuite')) {
        result.push({ label: '3 months', value: 3, weeklyPrice: price !== 0 ? price + 60 : 0 })
      }
    }

    const filteredResults =
      !!restrictedDuration && restrictedDuration.value > 0
        ? result.filter(item => item.value === restrictedDuration.value)
        : result

    return filteredResults.map(r => ({ ...r, label: `${r.label} - £${r.weeklyPrice}/pw` }))
  }

  const onSubmit = v => {
    const { membershipDuration } = v
    let floor =
      floorPreference && typeof floorPreference === 'string'
        ? JSON.parse(floorPreference)
        : floorPreference
    // $FlowFixMe
    floor = floor.value || floor
    const final = {
      membership:
        typeof membershipDuration === 'string'
          ? JSON.parse(membershipDuration)
          : membershipDuration,
      preferredFloor: floor,
      roomPrice,
      allow_cash: allow_cash === 'true',
      digitalVerification: digitalVerification === 'true',
      moveIn,
      occupancyType,
      room,
      yourName,
      adminFee,
      location,
      bookingDeposit,
      roomPriceEdited: roomPriceEdited === 'true',
      bookingDepositEdited: bookingDepositEdited === 'true'
    }

    if (dispatch && location && room) {
      dispatch(updateBooking(final))
      dispatch(push(`/${location.ref}/${room.ref}/secure`))
    }
  }

  return (
    <RoomSticky isAlignedAtStart={isAlignedAtStart}>
      <Title>Membership period</Title>
      <Divider />
      {!isNaN(price) && location && (
        <StyledForm onSubmit={handleSubmit && handleSubmit(onSubmit)} isWide>
          <Field
            name="membershipDuration"
            type="text"
            useFull
            component={mq.matches ? renderSelect : renderNativeSelect}
            isInitPage
            options={getDuration()}
            components={{ Option }}
            label="Select membership period to continue"
            validate={[required]}
          />
          <Button type="submit" uppercase>
            Apply
          </Button>
        </StyledForm>
      )}
    </RoomSticky>
  )
}

DetailForm = reduxForm({
  form: 'roomSelection',
  validate: values => {
    const errors = {}
    if (
      !values.membershipDuration ||
      (values.membershipDuration && values.membershipDuration.value === '')
    ) {
      errors.membershipDuration = 'Oh, you need to select a membership duration'
    }
    return errors
  }
})(DetailForm)

const mapStateToProps = (state: State, ownProps: Props) => {
  const {
    encryption: {
      decrypted: {
        allow_cash,
        occupancyType,
        moveIn,
        restrictedDuration,
        hasKitchen,
        preferredFloor,
        adminFee,
        bookingDeposit,
        roomPrice,
        yourName,
        hasRestrictedDuration,
        bookingDepositEdited,
        roomPriceEdited,
        digitalVerification
      }
    }
  } = state
  const { room } = ownProps
  const basePrice = room ? room.basePrice : 0
  return {
    floorPreference: preferredFloor,
    hasKitchen,
    occupancyType,
    allow_cash,
    bookingDepositEdited,
    roomPriceEdited,
    adminFee,
    yourName,
    bookingDeposit,
    digitalVerification,
    roomPrice: roomPrice || basePrice,
    hasRestrictedDuration,
    moveIn: moveIn ? JSON.parse(moveIn) : '',
    restrictedDuration: restrictedDuration ? JSON.parse(restrictedDuration) : ''
  }
}

// $FlowFixMe
export default connect(mapStateToProps, null)(DetailForm)



// WEBPACK FOOTER //
// ./src/containers/RoomDetailForm/components/DetailForm.js